export async function formatHtmlCode(source) {
    const [prettier, html, css, babel, estree] = await Promise.all([
        import('prettier/standalone'),
        import('prettier/plugins/html'),
        import('prettier/plugins/postcss'),
        import('prettier/plugins/babel'),
        import('prettier/plugins/estree'),
    ]);
    return prettier.format(source, {
        parser: 'html',
        plugins: [html, css, babel, estree],
        tabWidth: 2,
        useTabs: false,
        printWidth: 80,
        // Preserve meaningful whitespace between inline elements and text.
        htmlWhitespaceSensitivity: 'strict',
    });
}
